import { useLocalStorage } from "@rehooks/local-storage";

import { GET_STARTED_FEATURES } from "views/Account/LaunchPad/ChecklistSaaS/features";
import useSaaSOnboardingProgress from "views/Account/LaunchPad/ChecklistSaaS/useSaaSOnboardingProgress";

import DashboardOverviewColumnOnboardingLayout from "../OnboardingLayout";

const DashboardOverviewColumnOnboardingSaaS = () => {
  const [isOnboardingFinishedLocalStorage] = useLocalStorage(
    "dashboardWidgetOnboardingFinished",
    false
  );

  const {
    onboardingProgressInitialLoading,
    progressByFeature,
    isOnboardingComplete,
    error,
    refetch,
  } = useSaaSOnboardingProgress(isOnboardingFinishedLocalStorage);

  return (
    <DashboardOverviewColumnOnboardingLayout
      onboardingProgressInitialLoading={onboardingProgressInitialLoading}
      progressByFeature={progressByFeature}
      isOnboardingComplete={isOnboardingComplete}
      error={error}
      refetch={refetch}
      features={GET_STARTED_FEATURES}
    />
  );
};

export default DashboardOverviewColumnOnboardingSaaS;
